import { render, staticRenderFns } from "./pdfjs-viewer.vue?vue&type=template&id=714316cb&scoped=true&"
import script from "./pdfjs-viewer.vue?vue&type=script&lang=ts&"
export * from "./pdfjs-viewer.vue?vue&type=script&lang=ts&"
import style0 from "./pdfjs-viewer.vue?vue&type=style&index=0&id=714316cb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "714316cb",
  null
  
)

export default component.exports